import Article from '../Components/Article';
import { PageArticle } from './Post-Article';

export default function Home(){

    return(

    <div>
    menu
    <Article/>
    <PageArticle/>
    </div>
    )
}
